export const createTagsFromArrayData = (tags: any) => {
	const values: any = Object.values(tags);
	const keys = Object.keys(tags);
	let final: any = [];
	Array.from({ length: values[0].length }).forEach((_, index) => {
		let semifinal: any = [];
		keys.forEach((key) => {
			const splitTags = key.split('::');
			const tagObject: any = {
				TagName: splitTags[0],
				TagPropertyKey: splitTags[1],
				value: {
					valueType: splitTags[2],
					stringValues: [],
					boolValues: [],
					int64Values: [],
					int32Values: [],
					floatValues: [],
					nsvPlaceIdValues: [],
					overlappingPlaceValues: [],
				},
			};
			switch (splitTags[2]) {
				case 'VALUE_TYPE_STRING':
					tagObject.value.stringValues = [tags[key][index]];
					break;
				case 'VALUE_TYPE_INT64':
					tagObject.value.int64Values = [tags[key][index]];
					break;
				case 'VALUE_TYPE_INT32':
					tagObject.value.int32Values = [tags[key][index]];
					break;
				case 'VALUE_TYPE_DOUBLE':
					tagObject.value.floatValues = [tags[key][index]];
					break;
				case 'VALUE_TYPE_BOOLEAN':
					tagObject.value.boolValues = [Boolean(tags[key][index])];
					break;
				case 'VALUE_TYPE_NSV_PLACE_ID':
					tagObject.value.nsvPlaceIdValues = [tags[key][index]];
					break;
				case 'VALUE_TYPE_OVERLAPPING_PLACE':
					tagObject.value.overlappingPlaceValues = [tags[key][index]];
					break;
				default:
			}
			semifinal.push(tagObject);
		});
		final.push(semifinal);
	});
	return final;
};
